<template>
  <Main>
    <v-container>

      <v-row justify="center">
        <v-col cols="12">
          <v-card class="pa-5" shaped>
            <v-row dense>
              <v-col cols="12">
                <strong>TARGET HO APPROVAL</strong>
              </v-col>
            </v-row>
            <hr />
            <v-row>
                        <v-col md="3" sm="12">
                            <v-select color="red darken-1" v-model="SELECTED_MONTH_PERIOD" :items="VSELECT_MONTH_PERIOD" label="Month Period" dense outlined></v-select>
                        </v-col>
                        <v-col md="3" sm="12">
                            <v-select color="red darken-1" v-model="SELECTED_YEAR_PERIOD" :items="VSELECT_YEAR_PERIOD" label="Year Period" dense outlined></v-select>
                        </v-col>
                        <v-col md="6" sm="12">
                            <v-select color="red darken-1" item-text="BRANCH_CODE" item-value="BRANCH_CODE" v-model="SELECTED_BRANCH" :items="VSELECT_BRANCH" label="Select Branch" dense outlined></v-select>
                        </v-col>
                        <v-col class="text-right" md="12">
                            <v-btn small color="warning" @click="filterDataTable()">Search</v-btn>
                        </v-col>
                    </v-row>
            <v-row>
              <v-col cols="12">
                <v-card class="pa-3" outlined>
                  <v-card-title>
                    <v-text-field
                      color="red darken-1"
                      v-model="searchRole"
                      append-icon="mdi-magnify"
                      label="Search"
                      single-line
                      hide-details
                    ></v-text-field>
                  </v-card-title>
                    <v-data-table 
                    :headers="dtHeadersDetailTarget" 
                    :items="dtItemsDetailTarget" 
                    :search="searchRole" 
                    :loading="dtLoading" 
                    dense
                    single-expand
                    @click:row="handleClick"
                    class="elevation-1"
                    item-key="TARGET_ID"
                    loading-text="Fetching Data...">
                    </v-data-table>
                    
                    </br>
                   <div class="d-flex justify-center">                    
                    <!-- <v-btn @click="reject" small class="mx-1" color="error"
                      >REJECT</v-btn
                    > -->
                    <v-btn @click="approve" small class="mx-1" color="warning"
                      >APPROVE</v-btn
                    >
                  </div>
                </v-card>
              </v-col>
            </v-row>
          </v-card>
        </v-col>
      </v-row>
    </v-container>
    <!-- SNACKBAR -->
    <v-snackbar v-model="isShowSnackbar" top>{{ snackbarText }}</v-snackbar>
    <!-- LOADING OVERLAY -->
    <v-overlay :value="isLoading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </Main>
</template>

<script>
import Main from "@/Main.vue";
import moment from "moment";
import XLSX from "xlsx";

export default {
  components: {
    Main,
  },
  data() {
    return {
       dtHeadersDetailTarget: [{
                    text: "Month Periode",
                    value: "TGT_MONTH_ID"
                },
                {
                    text: "Year Periode",
                    value: "TGT_YEAR_ID"
                },
                {
                    text: "Cabang",
                    value: "BRANCH_CODE"
                },
                {
                    text: "Item / Subline",
                    value: "PRODUCT_SUB_LINE"
                },
                {
                    text: "Channel Outlet Group",
                    value: "OUTLET_CHANNEL_GROUP"
                },
                {
                    text: "Sales Person Position",
                    value: "ROLE_POSITION_CODE"
                },
                {
                    text: "SUM TGT Rekomendasi HO",
                    value: "VALUE_TGT_HO"
                },
                {
                    text: "SUM TGT Cabang",
                    value: "VALUE_TGT_CAB"
                }
            ],
      isLoading: false,
      isShowSnackbar: false,
      snackbarText: "",
      branchList: [],
      branch: null,
      searchRole: "",
      dtLoading: false,
      dtItems: [],
      position: "",
      invoiceNo: "",
      openPeriod: false,
     period: moment().format("YYYY-MM"),
      userIdUpdate: JSON.parse(localStorage.getItem('userData')).USER_ID,
      dtItemsDetailTarget: [],
      VSELECT_MONTH_PERIOD: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
      VSELECT_YEAR_PERIOD: [],
      SELECTED_BRANCH: "",
      SELECTED_YEAR_PERIOD: "",
      SELECTED_MONTH_PERIOD: ""
    };
  },
  mounted() {
    this.prepareData();
  },
  methods: {
     prepareData() {
            const DATE_NOW = new Date();

            this.SELECTED_MONTH_PERIOD = DATE_NOW.getMonth() + 1;
            this.SELECTED_YEAR_PERIOD = DATE_NOW.getFullYear();

            let YEAR = [];
            for (let i = 2000; i < DATE_NOW.getFullYear() + 25; i++) {
                this.VSELECT_YEAR_PERIOD.push(i);
            }

            this.dtLoading = true;
            this.$http
                .get("/target/selectBranch", {
                  headers: {
                    "api-key": this.$apiKey
                  }
                })
                .then(res => {
                    this.dtLoading = false;
                    const data = res.data.data;
                    this.VSELECT_BRANCH = data;
                })
                .catch(err => {
                    this.dtLoading = false;
                    this.showSnackbar(err.toString());
                });
        },
    filterDataTable() {
      this.dtLoading = true;
      let data = {
                MonthID: this.SELECTED_MONTH_PERIOD,
                YearID: this.SELECTED_YEAR_PERIOD,
                BranchCode: this.SELECTED_BRANCH
      };
      console.log('data ', data)
      this.$http
        .post("/target/approval", data, {
          headers: {
            "api-key": this.$apiKey
          }
        })
        .then((res) => {
          // if (!res.data.success || res.data.success == undefined) {
          //   console.log(res);
          // }
          let data = res.data.data.DetailTarget;
          console.log('datanya ', res.data.data.DetailTarget)
         
          this.dtLoading = false;
          this.dtItemsDetailTarget = data;
        })
        .catch((err) => {
          this.dtLoading = false;
          this.showSnackbar(err.toString());
        });
    },
    showSnackbar(text) {
      this.snackbarText = text;
      this.isShowSnackbar = true;
    },
    handleClick(value)
    {
      console.log('valcheck ',value)
    },
    approve() { 
       if (confirm(" Apakah Yakin akan lakukan submit?")) {
          this.isLoading = true;
           const USER_DATA = JSON.parse(localStorage.getItem("userData"));
          let data = {
                MonthID: this.SELECTED_MONTH_PERIOD,
                YearID: this.SELECTED_YEAR_PERIOD,
                BranchCode: this.SELECTED_BRANCH,
                USER_ID : USER_DATA.USER_ID
      };
      console.log('data ',)
          this.$http
            .post('/target/approve', data, {
              headers: {
                "api-key": this.$apiKey
              }
            })
            .then((res) => {
              this.isLoading = false;
              const data = res.data;
              if (data.success) {
                this.showSnackbar('Success..');
                this.selected = [];
                this.filterDataTable();
              } else {
                this.showSnackbar('Something is wrong..');
              }
            })
            .catch((err) => {
              this.isLoading = false;
              this.showSnackbar(err.toString());
            });
       }
			
		},
    // reject() {
    //   if (confirm(" Apakah Yakin akan lakukan Reject?")) {
    //       this.isLoading = true;
    //       this.$http
    //         .post('/target/reject', this.selected)
    //         .then((res) => {
    //           this.isLoading = false;
    //           const data = res.data;
    //           if (data.success) {
    //             this.showSnackbar('Success..');
    //             this.selected = [];
    //             this.filterDataTable();
    //           } else {
    //             this.showSnackbar('Something is wrong..');
    //           }
    //         })
    //         .catch((err) => {
    //           this.isLoading = false;
    //           this.showSnackbar(err.toString());
    //         });
    //   }			
		// },
  },
};
</script>
